// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
export type OwnerCreditCardFragment = { __typename?: 'OwnerCreditCardDTO', addCards: boolean, causalCancelPreauth: string | null, causalCharge: string | null, causalConfirm: string | null, causalPreautorization: string | null, causalRefund: string | null, chargeWithoutInvoice: boolean, checkCards: boolean, currencyIsoCode: string, defaultOwnerPaymentGatewayId: number | null, deleteCards: boolean, viewCards: boolean, viewCardsCvv: boolean };

export const OwnerCreditCardFragment = gql`
    fragment OwnerCreditCard on OwnerCreditCardDTO {
  addCards
  causalCancelPreauth
  causalCharge
  causalConfirm
  causalPreautorization
  causalRefund
  chargeWithoutInvoice
  checkCards
  currencyIsoCode
  defaultOwnerPaymentGatewayId
  deleteCards
  viewCards
  viewCardsCvv
}
    `;
/* eslint-enable */